// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-erroroverlay_container__3htic"};